import {
  admiral,
  bet2020,
  betflag, betland, betmatch,
  betplus, betpoint, betpremium, betstation, betup, clubgames, domusbet, elysgame, enjoybet,
  eurobet, fivebet, fullslot, giocoyes,
  gsbet, i7betplus, iambet, italianbet24, jokando, lovingbet, microgameDark, microgameLight,
  millionairebet,
  mst, netwin, newbetlive5k, newgioco,
  ngenge, onegol, originalbet,
  parimatch, pointbet, pokerbet, pokerblu, quibet,
  quigioco, riogames, sbancami, scommesseitalia,
  sisal,
  sks, sportanfgames, timetobet, timewin,
  trebet, vincitu, vincitubet,
  youbet
} from './cIDpartner';

export const environment = {
  production: true,
  uniqueCID: '335C6F67-81B1-4FE0-9DC2-1DDE8D6B4F7D',
  staging: true,

  apiUrl: {
    default: 'https://resthts-staging.mediasystemtechnologies.it/',
  },
  apiUrlTot: 'https://rest-staging.mediasystemtechnologies.it/',
  imgUrl: 'https://restippica-staging-az.mediasystemtechnologies.it/silks/images/',

  // apiUrl: {
  //   'FC4C0D8B-F663-42FA-92BC-1AEF9C7C2901': 'https://fe-proxyhts-gamenet-mst-int.mstchannel.com/', // GameNet - Goldbet
  //   '6C0EA555-2DA3-44B4-BC97-3A32368E2853': 'https://fe-proxyhts-sisal-mst-int.mstchannel.com/', // Sisal
  //   default: 'https://fe-proxyhts-online-mst-int.mstchannel.com/'
  // },
  // apiUrlTot: 'https://fe-proxyhts-tot-mst.mstchannel.com/',
  // imgUrl: 'https://fe-dataupload-mst.mstchannel.com/images/',

  urlStats: {
    '459918A2-A1CB-4211-8DB3-A8D43688C279': 'https://ippica.mediasystemtechnologies.it/stats.aspx',
    default: 'https://ippica.mediasystemtechnologies.it/stats.aspx',
  },

  countryStats: [
    '208', // SVEZIA
    '65',  // FRANCIA
    // '203', // SUDAFRICA
    '171', // REGNO UNITO
    '55',  // IRLANDA
    '112',  // ITALIA
    '202', // USA
    '13', // AUSTRALIA
    '51', // DANIMARCA
    '69' // GERMANIA
  ],
  excludeBet: {
    '1': [],
    '2': [],
    '3': [],
    '4': [],
    '5': [],
    '6': [],
    '7': [],
    '8': [],
    '9': [],
    '10': [],
    '11': [],
    '12': [],
    '14': [],
    '16': [],
    '18': [],
    '22': [],
    '23': [],
    '24': []
  },

  replayIdPartner: [
      '2',
      '7',
      '12'
  ],

  /* TODO per le personalizzazioni togliere questi parametri e usare il file cIDpartner direttamenete*/
  betflafCID: betflag,
  sisalCID: sisal,
  sksCID: sks,
  parimCID: parimatch,
  quigiocoCID: quigioco,
  youbetCID: youbet,
  trebetCID: trebet,
  bet2020CID: bet2020,
  betplusCID: betplus,
  gsbetCID: gsbet,
  millionairebetCID: millionairebet,
  mstCID: mst.concat(ngenge).concat(parimatch),
  mstdarkCID: microgameDark,
  mstlightCID: microgameLight,
  eurobetCID: eurobet,
  betlandCID: betland,
  enjoybetCID: enjoybet,
  riogamesCID: riogames,
  betupCID: betup,
  scommesseitaliaCID: scommesseitalia,
  betpointCID: betpoint,
  newgiocoCID: newgioco,
  originalbetCID: originalbet,
  lovingbetCID: lovingbet,
  timetobetCID: timetobet,
  clubgamesCID: clubgames,
  quibetCID: quibet,
  newbetlive5kCID: newbetlive5k,
  elysgameCID: elysgame,
  betstationCID: betstation,
  domusbetCID: domusbet,
  betpremiumCID: betpremium,
  jokandoCID: jokando,
  netwinCID: netwin,
  admiralCID: admiral,
  betmatchCID: betmatch,
  fivebetCID: fivebet,
  fullslotCID: fullslot,
  giocoyesCID: giocoyes,
  i7betplusCID: i7betplus,
  iambetCID: iambet,
  onegolCID: onegol,
  pointbetCID: pointbet,
  poketbetCID: pokerbet,
  sportanfgamesCID: sportanfgames,
  timewinCID: timewin,
  vincituCID: vincitu,
  vincitubetCID: vincitubet,

  enableSlack: true,
  slackTranslateChannel: 'BTXDYPZV1/bkXrrmAhuWel34f6EG3sYNpy',
  appInsightsConfig: {
    instrumentationKey: 'e83a2db8-71f8-4831-a56f-e0ad28928a39',
    environment: 'staging',
  },
  cacheBusterHash: 'cb3c3a5c977bace1486a2f26ff6176e2',
  google: {
    analytics: {
      active: true,
      logging: {
        debug: true,
        exceptions: true,
        verbose: true,
      },
    },
    ciD: parimatch
  },
  /* Deprecato uso cID come parametro */
  theme: {
  },
  cID: {
    // Custom Theme
    '6C9D1588-A442-4CB5-99A7-CE542CB578CF': { // staging Betflag
      name: 'Betflag',
      theme: 'betflag',

      customCss: true,
      link: 'theme-betflag'
      // theme: 'sisal',
      // customCss: true,
      // link: 'theme-sisal'
    },
    '6770EB7C-32F4-42C2-9E29-9DAE9FFB3898': { // Staging Test EuroBet
      name: 'EuroBet',
      theme: 'mst',
      customCss: true,
      link: 'theme-eurobet'
    },
    '72272D57-7598-4C4E-BC76-F1BF142C8E74': { // Staging Sisal
      name: 'Sisal',
      theme: 'sisal',
      customCss: true,
      link: 'theme-sisal'
    },
    '10802F1D-3F51-4B96-A115-9CA509189918': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    '98F0D64C-D8C1-4CC3-AF52-4226D36C5523': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    'C0DEB55D-76CD-4FDE-9C08-DE18CDEB89DE': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    'D37557F1-E450-41B8-8CD2-ED83F94D98CE': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    'E10B8B46-DC28-404B-8BC9-16C205AAF1FD': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    '72089B4F-F5B4-4A82-869C-D229B3A6B1FB': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    '8833198D-058C-40D4-90B1-FE50AA1068A8': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    'AED570D8-A01F-4A30-9F57-FD5FDF0EBFBA': { // Staging pariMatch
      name: 'pariMatch',
      theme: 'pm',
      customCss: true,
      link: 'theme-pm'
    },
    'C112A683-C568-4A8B-8BF9-8F64DEF62ED1': { // Staging Test SKS
      name: 'PalnetWin365',
      theme: 'sks',
      customCss: true,
      link: 'theme-sks',
      sass: 'sks'
    },
    '5624C27E-FC36-4213-8841-7A1E2B5AACF8': { // Staging Test Gamenet
      name: 'Gamenet',
      theme: 'gold',
      customCss: true,
      link: 'theme-gold'
    },
    '575793F3-9653-48DA-A545-4587E19F07E3': { // Staging Test Gamenet APP
      name: 'Gamenet APP',
      theme: 'gold',
      customCss: true,
      link: 'theme-gold-app'
    },
    '314C2F59-6962-4F5C-B395-E679E7826B5B': { // Staging Lottomatica
      name: 'Lottomatica',
      theme: 'gold',
      customCss: true,
      link: 'theme-lottomatica'
    },
    '645F7AEA-83BD-481A-A29A-9DE171F83589': { // Staging Lottomatica APP
      name: 'Lottomatica APP',
      theme: 'gold',
      customCss: true,
      link: 'theme-lottomatica-app'
    },
    '0D9E3A88-9EC5-434C-9C78-E940B375ABFD': { // Staging Quigioco HBG
      name: 'Quigioco HBG',
      theme: 'qg',
      customCss: true,
      link: 'theme-hbg',
      sass: 'hbg'
    },
    '7AF997B2-643C-4638-8B46-C93B11B45A61': {  // Staging Youbet HBG
      name: 'Youbet HBG',
      theme: 'yb',
      customCss: true,
      link: 'theme-hbg',
      sass: 'hbg'
    },
    '150393B2-B74C-48ED-83E5-2F3ACC1FC4A2': { // Staging BET2020 HBG
      name: 'BET2020 HBG',
      theme: 'bet2020',
      customCss: true,
      link: 'theme-hbg',
      sass: 'hbg'
    },
    'EC458504-9D92-4E6A-BBCE-3C4C28060A41': { // Staging TREBET HBG
      name: 'TREBET HBG',
      theme: 'trebet',
      customCss: true,
      link: 'theme-hbg',
      sass: 'hbg'
    },
    'DC5840B5-85B5-41EA-969F-BF0C41BFDE59': { // Staging BETPLUS365
      name: 'BETPLUS365',
      theme: 'bp',
      customCss: true,
      link: 'theme-hbg',
      sass: 'hbg'
    },
    '8335158B-1B2F-4348-957B-51553F4FD268': { // Staging millionairebet
      name: 'millionairebet',
      theme: 'yb',
      customCss: true,
      link: 'theme-hbg'
    },
    '17C728ED-82D3-4C49-8B32-0DC86E0F38C2': { // BETPOINT
      name: 'BETPOINT',
      theme: 'betpoint',
      customCss: true,
      link: 'theme-betpoint'
    },
    '31EFD458-DAAD-453D-A1FF-1E52CDD2F809': { // JOYGAMES
      name: 'JOYGAMES',
      theme: 'betpoint',
      customCss: true,
      link: 'theme-betpoint'
    },
    '17F33881-FF7F-4C2A-B312-CF26188B6BDB': { // EDICOLAGAMES
      name: 'EDICOLAGAMES',
      theme: 'betpoint',
      customCss: true,
      link: 'theme-betpoint'
    },
    '76A629F4-CAC5-4542-9B90-8429D01E2C30': { // wintimecasino
      name: 'wintimecasino',
      theme: 'betpoint',
      customCss: true,
      link: 'theme-betpoint'
    },
    // Default Theme ***********************************************************************************************************************
    '2F1ABD87-5863-4BCA-BEA8-155E4CA42741': { // Staging MST
      name: 'MST',
      theme: 'betflag',
      customCss: true,
      link: 'theme-betflag'
    },
    'C9462668-B58F-4AA0-B65A-3124CDB5C520': { // Staging WinGames NON E' ONLINE
      name: 'WinGames',
      theme: 'mst',
      customCss: false
    },
    'FB4BC686-CCF0-4A88-BB1A-B10D2D08F35A': { // Staging Test Pinterbet
      name: 'Pinterbet',
      theme: 'mst',
      customCss: false
    },
    '338AE1BC-2DA8-4CE5-9DC7-DC5121184B1E': { // Staging Test Vincitu
      name: 'Vincitu',
      theme: 'mst',
      customCss: false,
      sass: 'vincitu'
    },
    '5041E7DD-5924-4F7F-8405-43C5FE8BD621': { // Staging Test ngenge NON E' ONLINE
      name: 'ngenge',
      theme: 'mst',
      customCss: false
    },
    'BF82CF2C-CCB7-4826-AF61-27F825BFEB7F': { // Staging Test ngenge NON E' ONLINE
      name: 'ngenge',
      theme: 'mst',
      customCss: false
    },
    '3C2AF2FD-08EE-4DE1-A4EC-0A19132D6B48': { // Staging Test ngenge NON E' ONLINE
      name: 'ngenge',
      theme: 'mst',
      customCss: false
    },

    '11522B8F-8D18-467E-AFBC-7168E826BB56': { // Staging Test Microgame
      name: 'Microgame',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#000',
      brandColorTxt: '#fff'
    },
    '64C08DAC-6E4C-40EB-870C-58D5ED32D768': { // Staging Test Microgame
      name: 'Microgame Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#ff7b03',
      brandColorTxt: '#fff'
    },

    '74FB227A-8A74-4962-0001-8848BE685C16': { // Staging Betsense Test Microgame
      name: 'Betsense',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#ff7b03',
      brandColorTxt: '#fff'
    },
    '74FB227A-8A74-4962-0002-8848BE685C16': { // Staging Betsense Test Microgame dark
      name: 'Betsense Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#ff7b03',
      brandColorTxt: '#fff'
    },

    'D68739D9-240D-47AF-0001-EC6CB4528AE2': { // Staging Microgamenewbos LIGHT
      name: 'Microgamenewbos',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#ff7b03',
      brandColorTxt: '#fff'
    },
    'D68739D9-240D-47AF-0002-EC6CB4528AE2': { // Staging Microgamenewbos dark
      name: 'Microgamenewbos Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#ff7b03',
      brandColorTxt: '#fff'
    },

    'D74209E4-4920-4A87-0001-FC5581F58CD0': { // Staging Puntoscommesse Test Microgame
      name: 'Puntoscommesse',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#125A83',
      brandColorTxt: '#fff'
    },
    'D74209E4-4920-4A87-0002-FC5581F58CD0': { // Staging Puntoscommesse Test Microgame dark
      name: 'Puntoscommesse Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#125A83',
      brandColorTxt: '#fff'
    },

    'E70F45DD-2803-478B-0001-0A06E2350549': { // Staging Giochitelematici Test Microgame
      name: 'Giochitelematici',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#1F3262',
      brandColorTxt: '#fff'
    },
    'E70F45DD-2803-478B-0002-0A06E2350549': { // Staging Giochitelematici Test Microgame dark
      name: 'Giochitelematici Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#1F3262',
      brandColorTxt: '#fff'
    },

    '089CF0AB-7771-4376-0001-F063068028A5': { // Staging Mediabet Test Microgame
      name: 'Mediabet',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#E62D33',
      brandColorTxt: '#fff'
    },
    '089CF0AB-7771-4376-0002-F063068028A5': { // Staging Mediabet Test Microgame dark
      name: 'Mediabet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#E62D33',
      brandColorTxt: '#fff'
    },

    // Gazzabet
    '5ABDD1C3-95D6-4840-0001-1A2328373498': {
      name: 'Gazzabet',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#C20057',
      brandColorTxt: '#fff'
    },
    // Giocaagile
    '550E6A37-17F0-481E-0001-057EA7AB103B': {
      name: 'Giocaagile',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#DA0812',
      brandColorTxt: '#fff'
    },
    // Airbet
    '332EA976-4830-4172-0001-E0BEE253DBBE': {
       name: 'Airbet',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#1AABE1',
      brandColorTxt: '#fff'
    },
    // Monkeybet
    '5E84A947-AE1B-4AC7-0001-5888353DA73E': {
       name: 'Monkeybet',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#8AC143',
      brandColorTxt: '#fff'
    },
    // Venetianbet
    '104914B4-FB0B-4129-0001-5E980323B6A9': {
       name: 'Venetianbet',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#39A935',
      brandColorTxt: '#fff'
    },

    // Gazzabet Dark
    '5ABDD1C3-95D6-4840-0002-1A2328373498': {
      name: 'Gazzabet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#C20057',
      brandColorTxt: '#fff'
    },
    // Giocaagile Dark
    '550E6A37-17F0-481E-0002-057EA7AB103B': {
      name: 'Giocaagile Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#DA0812',
      brandColorTxt: '#fff'
    },
    // Airbet Dark
    '332EA976-4830-4172-0002-E0BEE253DBBE': {
      name: 'Airbet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#1AABE1',
      brandColorTxt: '#fff'
    },
    // Monkeybet dark
    '5E84A947-AE1B-4AC7-0002-5888353DA73E': {
      name: 'Monkeybet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#8AC143',
      brandColorTxt: '#fff'
    },
    // Venetianbet Dark
    '104914B4-FB0B-4129-0002-5E980323B6A9': {
      name: 'Venetianbet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#39A935',
      brandColorTxt: '#fff'
    },

    // bgbet dark
    '8106DBF5-895B-41C9-0002-CF415BEB025C': {
      name: 'bgbet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#EAC30C',
      brandColorTxt: '#000'
    },
    // bgbet light
    '8106DBF5-895B-41C9-0001-CF415BEB025C': {
      name: 'bgbet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#EAC30C',
      brandColorTxt: '#000'
    },

// MG REPLATZ (15073) Betman LIGHT
'E8CD9BBD-BF67-4156-0001-8F79C7950207': {
  name: 'Betman light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#e51e25',
      brandColorTxt: '#fff'
},
// MG REPLATZ (15073) Betman DARK
'E8CD9BBD-BF67-4156-0002-8F79C7950207': {
  name: 'Betman dark',
      theme: 'mst-dark',
      customCss: false,
      link: 'theme-microgame-dark',
      brandColor: '#e51e25',
      brandColorTxt: '#fff'
},

// MG REPLATZ (15073) Replatz LIGHT
'6CBB64AF-3BFA-43F0-0001-9031DA2403C8': {
  name: 'Replatz light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#D23C27',
      brandColorTxt: '#fff'
},
// MG REPLATZ (15073) Replatz DARK
'6CBB64AF-3BFA-43F0-0002-9031DA2403C8': {
  name: 'Replatz dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#D23C27',
      brandColorTxt: '#fff'
},

// MG GI.LU.PI. (15074) Giocasempre LIGHT
'E62C3DEA-20FD-4F13-0001-0EE8487DB021': {
  name: 'Giocasempre light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#fc0',
      brandColorTxt: '#000',
      mobileHeight: 0
},
// MG GI.LU.PI. (15074) Giocasempre DARK
'E62C3DEA-20FD-4F13-0002-0EE8487DB021': {
  name: 'Giocasempre dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#fc0',
      brandColorTxt: '#000',
      mobileHeight: 0
},
// MG GI.LU.PI. (15074) Betscore LIGHT
'06EEBAC3-7100-45EA-0001-EE42F1327911': {
  name: 'Betscore light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#26619b',
      brandColorTxt: '#fff',
      mobileHeight: 0
},
// MG GI.LU.PI. (15074) Betscore DARK
'06EEBAC3-7100-45EA-0002-EE42F1327911': {
  name: 'Betscore dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#26619b',
      brandColorTxt: '#fff',
      mobileHeight: 0
},
// MG GI.LU.PI. (15074) Betitaly LIGHT
'08E2817C-6E8D-4BAE-0001-F7C7882BD063': {
  name: 'Betitaly light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#0d1a51',
      brandColorTxt: '#fff'
},
// MG GI.LU.PI. (15074) Betitaly DARK
'08E2817C-6E8D-4BAE-0002-F7C7882BD063': {
  name: 'Betitaly dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#0d1a51',
      brandColorTxt: '#fff'
},
// MG PLIVIO (15092) Eventogioco LIGHT
'F8864412-00EE-47D3-0001-9DA5F7108F89': {
  name: 'Eventogioco light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#EAC30C',
      brandColorTxt: '#000'
},
// MG PLIVIO (15092) Eventogioco DARK
'F8864412-00EE-47D3-0002-9DA5F7108F89': {
  name: 'Eventogioco light',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#F4B936',
      brandColorTxt: '#212121'
},
// MG PLIVIO (15092) Eventogiocobet LIGHT
'9439F5C1-0697-435E-0001-BA008138741D': {
  name: 'Eventogiocobet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#F4B936',
      brandColorTxt: '#212121'
},
// MG PLIVIO (15092) Eventogiocobet DARK
'9439F5C1-0697-435E-0002-BA008138741D': {
  name: 'Eventogiocobet light',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#F4B936',
      brandColorTxt: '#000'
},
// MG VITTORIA BET 2009 (15188) Deabet LIGHT
'9236D5AA-AB59-473B-0001-276FB0429BD1': {
  name: 'Deabet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#C39A4C',
      brandColorTxt: '#fff'
},
// MG VITTORIA BET 2009 (15188) Deabet DARK
'9236D5AA-AB59-473B-0002-276FB0429BD1': {
  name: 'Deabet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#C39A4C',
      brandColorTxt: '#fff'
},
// MG VITTORIA BET 2009 (15188) Chancebet LIGHT
'BA2F4385-A537-46B2-0001-86EDB3F42262': {
  name: 'Chancebet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#E97107',
      brandColorTxt: '#fff'
},
// MG VITTORIA BET 2009 (15188) Chancebet DARK
'BA2F4385-A537-46B2-0002-86EDB3F42262': {
  name: 'Chancebet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#E97107',
      brandColorTxt: '#fff'
},
// MG VITTORIA BET 2009 (15188) Andromedabet LIGHT
'F9251ED8-B9CF-401C-0001-8A64E8B50E93': {
  name: 'Andromedabet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#C6101E',
      brandColorTxt: '#fff'
},
// MG VITTORIA BET 2009 (15188) Andromedabet DARK
'F9251ED8-B9CF-401C-0002-8A64E8B50E93': {
  name: 'Andromedabet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#C6101E',
      brandColorTxt: '#fff'
},
// MG VITTORIA BET 2009 (15188) Lafenicebet LIGHT
'9E997CDF-F7F8-49A7-0001-92C7D18C28F5': {
  name: 'Lafenicebet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#f8c45e',
      brandColorTxt: '#000',
      mobileHeight: 0
},
// MG VITTORIA BET 2009 (15188) Lafenicebet DARK
'9E997CDF-F7F8-49A7-0002-92C7D18C28F5': {
      name: 'Lafenicebet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#f8c45e',
      brandColorTxt: '#000',
      mobileHeight: 0
},
// MG VITTORIA BET 2009 (15188) Bettime LIGHT
'7BB8BF4C-8B31-4AF0-0001-A90F9F051683': {
  name: 'Bettime light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#0a2f6c',
      brandColorTxt: '#fff',
      mobileHeight: 54
},
// MG VITTORIA BET 2009 (15188) Bettime DARK
'7BB8BF4C-8B31-4AF0-0002-A90F9F051683': {
  name: 'Bettime dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#0a2f6c',
      brandColorTxt: '#fff',
      mobileHeight: 54
},
// MG VITTORIA BET 2009 (15188) Wintoto LIGHT
'EE17B44E-77E9-482B-0001-D0AB2E1E17B2': {
  name: 'Wintoto light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#f02424',
      brandColorTxt: '#fff'
},
// MG VITTORIA BET 2009 (15188) Wintoto DARK
'EE17B44E-77E9-482B-0002-D0AB2E1E17B2': {
  name: 'Wintoto dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#f02424',
      brandColorTxt: '#fff',
},
// MG TOTOSI (15405) Totosi LIGHT
'04E8007B-5737-40CC-0001-5B0F64169708': {
  name: 'totosi light',
      theme: 'mst',
      customCss: true,
      link: 'theme-totosi-ippica-light',
      brandColor: '#45E645',
      brandColorTxt: '#081533',
      mobileHeight: 62
},
// MG TOTOSI (15405) Totosi DARK
'04E8007B-5737-40CC-0002-5B0F64169708': {
  name: 'totosi dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-totosi-ippica-dark',
      brandColor: '#45E645',
      brandColorTxt: '#081533',
      mobileHeight: 62
},


// MG PLAYMATIKA (15411) Betnow LIGHT
'1DC89CFB-1763-40F7-0001-1C11644DCD62': {
  name: 'Betnow light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#FECB32',
      brandColorTxt: '#000'
},
// MG PLAYMATIKA (15411) Betnow DARK
'1DC89CFB-1763-40F7-0002-1C11644DCD62': {
  name: 'Betnow dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#FECB32',
      brandColorTxt: '#000'
},
// MG PLAYMATIKA (15411) Playmatika LIGHT
'03FCFEA9-C818-4C24-0001-A416DCEBB975': {
  name: 'Playmatika light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#E5262A',
      brandColorTxt: '#fff'
},
// MG PLAYMATIKA (15411) Playmatika DARK
'03FCFEA9-C818-4C24-0002-A416DCEBB975': {
  name: 'Playmatika light',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#E5262A',
      brandColorTxt: '#fff'
},
// 15411	MG PLAYMATIKA (15411) Betpassion LIGHT
'65E26070-E679-4544-0001-FB45A4E0964D': {
  name: 'Betpassion light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#54af3a',
      brandColorTxt: '#fff'
},
// 15411	MG PLAYMATIKA (15411) Betpassion DARK
'65E26070-E679-4544-0002-FB45A4E0964D': {
  name: 'Betpassion dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#54af3a',
      brandColorTxt: '#fff'
},
// 15459 MG GIOCONDABET (15459) Giocondabet LIGHT
'54F0DDFE-D936-4637-0001-E4B319EE5173': {
  name: 'Giocondabet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#FF0000',
      brandColorTxt: '#fff'
},
// 15459 MG GIOCONDABET (15459) Giocondabet DARK
'54F0DDFE-D936-4637-0002-E4B319EE5173': {
  name: 'Giocondabet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#FF0000',
      brandColorTxt: '#fff'
},
// 15469	MG SLOT PLUS (15469) Chescommessa LIGHT
'13E3D502-9EA8-412F-0001-29E00512EB0D': {
  name: 'Chescommessa light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#4CAF4D',
      brandColorTxt: '#fff'
},
// 15469	MG SLOT PLUS (15469) Chescommessa DARK
'13E3D502-9EA8-412F-0002-29E00512EB0D': {
  name: 'Chescommessa dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#4CAF4D',
      brandColorTxt: '#fff'
},
// 15469	MG SLOT PLUS (15469) Signorbet LIGHT
'E1AF081A-FFA0-4255-0001-349E05D48773': {
  name: 'Signorbet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#E5103A',
      brandColorTxt: '#fff'
},
// 15469	MG SLOT PLUS (15469) Signorbet DARK
'E1AF081A-FFA0-4255-0002-349E05D48773': {
  name: 'Signorbet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#E5103A',
      brandColorTxt: '#fff'
},
// 15473	MG WIN BET ONLINE (15473) Winbet LIGHT
'350A1AD6-B06D-403E-0001-177AD81D4F4A': {
  name: 'Winbet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#ff0023',
      brandColorTxt: '#fff'
},
// 15473	MG WIN BET ONLINE (15473) Winbet DARK
'350A1AD6-B06D-403E-0002-177AD81D4F4A': {
  name: 'Winbet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#ff0023',
      brandColorTxt: '#fff'
},
// 15479	MG ITALY GAMING (15479) Elabet LIGHT
'A191D31B-849B-4329-0001-737FE16B32E9': {
  name: 'Elabet',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#1A8E18',
      brandColorTxt: '#fff'
},
// 15479	MG ITALY GAMING (15479) Elabet DARK
'A191D31B-849B-4329-0002-737FE16B32E9': {
  name: 'Elabet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#1A8E18',
      brandColorTxt: '#fff'
},

// 15479 15188	15188	29	MG VITTORIA BET 2009 (15188) Tiltbet LIGHT
'4190C345-52D7-472D-0001-CE14B04C7125': {
  name: 'Tiltbet light',
  theme: 'mst',
  customCss: true,
  link: 'theme-microgame-light',
  brandColor: '#f25600',
  brandColorTxt: '#fff',
  mobileHeight: 58
},

// 15479 15188	15188	29	MG VITTORIA BET 2009 (15188) Tiltbet LIGHT
'4190C345-52D7-472D-0002-CE14B04C7125': {
  name: 'Tiltbet dark',
  theme: 'mst-dark',
  customCss: true,
  link: 'theme-microgame-dark',
  brandColor: '#f25600',
  brandColorTxt: '#fff',
  mobileHeight: 58
},


// MG STREET WEB (15245) Acbet LIGHT
'98778980-8BBC-4C99-0001-21FBACC5F3F0': {
  name: 'Acbet light',
  theme: 'mst',
  customCss: true,
  link: 'theme-microgame-light',
  brandColor: '#FAB316',
  brandColorTxt: '#000'
},

// MG STREET WEB (15245) Apbet LIGHT
'46E286A7-4184-411E-0001-59DF14E43705': {
  name: 'Apbet light',
  theme: 'mst',
  customCss: true,
  link: 'theme-microgame-light',
  brandColor: '#d11b28',
  brandColorTxt: '#fff',
  mobileHeight: 58
},

// MG STREET WEB (15245) Galaxybet LIGHT
'710D09A0-BAEE-4DA4-0001-C473D54DC28F': {
  name: 'Galaxybet light',
  theme: 'mst',
  customCss: true,
  link: 'theme-microgame-light',
  brandColor: '#e30713',
  brandColorTxt: '#fff',
  mobileHeight: 58
},
// MG STREET WEB (15245) Mpbet LIGHT
'1FA5A573-E6D8-46B7-0001-A0CE5CAFD2B8': {
  name: 'Mpbet light',
  theme: 'mst',
  customCss: true,
  link: 'theme-microgame-light',
  brandColor: '#ae0f0a',
  brandColorTxt: '#fff',
  mobileHeight: 50
},

// MG STREET WEB (15245) Powerbet LIGHT
'0A851CB3-D1F8-4325-0001-9F2DE35E4702': {
  name: 'Powerbet light',
  theme: 'mst',
  customCss: true,
  link: 'theme-microgame-light',
  brandColor: '#59C844',
  brandColorTxt: '#fff'
},

// MG STREET WEB (15245) Terrybet LIGHT
'515A8BE5-6F2D-4966-0001-C72EEFFA8DDE': {
  name: 'Terrybet light',
  theme: 'mst',
  customCss: true,
  link: 'theme-microgame-light',
  brandColor: '#1397d5',
  brandColorTxt: '#fff'
},

// MG STREET WEB (15245) Acbet DARK
'98778980-8BBC-4C99-0002-21FBACC5F3F0': {
  name: 'Acbet Dark',
  theme: 'mst-dark',
  customCss: true,
  link: 'theme-microgame-dark',
  brandColor: '#FAB316',
  brandColorTxt: '#000'
},

// MG STREET WEB (15245) Apbet DARK
    '46E286A7-4184-411E-0002-59DF14E43705': {
      name: 'Apbet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#d11b28',
      brandColorTxt: '#fff',
      mobileHeight: 58
    },

// MG STREET WEB (15245) Galaxybet DARK
    '710D09A0-BAEE-4DA4-0002-C473D54DC28F': {
      name: 'Galaxybet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#e30713',
      brandColorTxt: '#fff',
      mobileHeight: 58
    },
// MG STREET WEB (15245) Mpbet DARK
    '1FA5A573-E6D8-46B7-0002-A0CE5CAFD2B8': {
      name: 'Mpbet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#ae0f0a',
      brandColorTxt: '#fff',
      mobileHeight: 50
    },

// MG STREET WEB (15245) Powerbet DARK
    '0A851CB3-D1F8-4325-0002-9F2DE35E4702': {
      name: 'Powerbet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#59C844',
      brandColorTxt: '#fff'
    },

// MG STREET WEB (15245) Terrybet DARK
    '515A8BE5-6F2D-4966-0002-C72EEFFA8DDE': {
      name: 'Terrybet Dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#1397d5',
      brandColorTxt: '#fff'
    },

    'C94B3FE0-5EA1-45D9-9D1E-FD30819C000B': { // Staging Test btobet
      name: 'btobet',
      theme: 'mst',
      customCss: false
    },
    'D789CE11-11BA-498C-BDFA-A1F638712321': { // Staging Test Moretti
      name: 'Moretti',
      theme: 'mst',
      customCss: false
    },
    '634FED17-7514-48A5-8B17-468B6C0C4E33': { // Staging Test Betaland OIA
      name: 'Betaland OIA',
      theme: 'mst-dark',
      customCss: false,
      sass: 'oia'
    },
    '8275C9EB-F76D-4C49-8FB9-35A1536799C6': { // Staging Test Enjoybet OIA
      name: 'Enjoybet OIA',
      theme: 'mst-dark',
      customCss: false,
      sass: 'oia'
    },
    '90A0DCA8-C841-433A-A9BE-DC8B11119073': { // Staging Test Riogames OIA
      name: 'Riogames OIA',
      theme: 'mst-dark',
      customCss: false,
      sass: 'oia'
    },
    '92D9DE6E-D2C7-4DA1-8183-18816E9AD5C9': { // Staging stoloto
      name: 'stoloto',
      theme: 'sks',
      customCss: false,
    },
    'BB4A84C3-B8E8-4A7E-BE6E-0B6285A35132': { // Staging Betup
      name: 'Betup',
      theme: 'mst-dark',
      customCss: false,
      sass: 'scommesse-italia'
    },
    '3478090C-8C35-48FF-AC74-1CFEDE1CD433': { // Staging Italianbet24
      name: 'Italianbet24',
      theme: 'mst',
      customCss: false,
      sass: 'scommesse-italia'
    },
    'FE1F6A27-B7D6-4525-80C2-00F7A7EA4239': { // Staging Scommesse Italia
      name: 'Scommesse Italia',
      theme: 'mst',
      customCss: false,
      sass: 'scommesse-italia'
    },
    'F14C3ADB-1FE6-4FD0-ACDA-807094551BD2': { // Staging Sbancami
      name: 'Sbancami',
      theme: 'mst-dark',
      customCss: false,
      sass: 'scommesse-italia'
    },
    '0377EF16-494D-42F9-98EB-ED7373AF4D52': { // Staging Pokerblu
      name: 'Pokerblu',
      theme: 'mst-dark',
      customCss: false,
      sass: 'scommesse-italia'
    },
    '646A8A61-C268-4E33-86B7-7DBF8B392179': { // Staging SPORTBET
      name: 'SPORTBET',
      theme: 'sportbet',
      customCss: false
    },
    'B32F14E3-BE89-4723-9FF6-19883644FCCD': { // SPORTBET - BET9
      name: 'BET9',
      theme: 'sportbet',
      customCss: false
    },
    '13A8C3E1-B5EC-4E5C-8FDF-0C593B2E987B': { // SPORTBET - BETNAPOLI
      name: 'BETNAPOLI',
      theme: 'sportbet',
      customCss: false
    },
    '086AAA29-4D2E-4D7E-9C0F-C32A95A9F3B1': { // SPORTBET - BETNEW
      name: 'BETNEW',
      theme: 'sportbet',
      customCss: false
    },
    '58BAD20A-2B1B-49F6-9A68-B5D0E21D6AF1': { // SPORTBET - BETSTARS365
      name: 'BETSTARS365',
      theme: 'sportbet',
      customCss: false
    },
    '9BC2B306-B1FE-4BD1-8576-43DE54153954': { // SPORTBET - BETWILL
      name: 'BETWILL',
      theme: 'sportbet',
      customCss: false
    },
    'BC794256-3B5A-44A8-99F0-83EC7FAC0681': { // SPORTBET - BETX
      name: 'BETX',
      theme: 'sportbet',
      customCss: false
    },
    '06CBD7E9-543C-475F-860D-1E40B83EE80E': { // SPORTBET - FULLSLOT
      name: 'FULLSLOT',
      theme: 'sportbet',
      customCss: false
    },
    '97E42742-1FF6-42F6-980E-0B143CF0F912': { // SPORTBET - STARGAME
      name: 'STARGAME',
      theme: 'sportbet',
      customCss: false
    },
    '6B27A46A-6722-493A-BA16-7D5D1A684C64': { // SPORTBET - VSTART.IT
      name: 'VSTART.IT',
      theme: 'sportbet',
      customCss: false
    },
    '1FE4F7B6-1FE6-4BC8-827A-40BC4B72076F': { //  DOMUSBET - BETSTATION
      name: 'BETSTATION',
      theme: 'mst-dark',
      customCss: false,
      sass: 'domusbet'
    },
    'A752844B-A8A9-4908-95E8-D42D1AB1CD0E': { //  DOMUSBET - DOMUSBET
      name: 'DOMUSBET',
      theme: 'mst-dark',
      customCss: false,
      sass: 'domusbet'
    },
    '9BD2F0A1-B52A-4E88-A718-1BB34E2EA1C3': { // MULTIGIOCO - CLUBGAMES
      name: 'CLUBGAMES',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '71567E37-DC11-48D6-A151-00AFBA37244E': { // MULTIGIOCO - DREAMCASINO
      name: 'DREAMCASINO',
      theme: 'multigioco-light',
      customCss: false,
      sass: 'multigioco'
    },
    '43849BCB-B83B-4049-A8A8-54ACA8B43C39': { // MULTIGIOCO - ELYSGAME
      name: 'ELYSGAME',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '2F6106DB-4A68-40B7-B3E8-A7691E70E9DC': { // MULTIGIOCO - LOVINGBET
      name: 'LOVINGBET',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    'A6B987F8-DA26-468C-898E-27D71CBAA53C': { // MULTIGIOCO - NEWBETLIVE5k
      name: 'NEWBETLIVE5k',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '5A9F3ABC-06D7-435F-8A8F-651DD98C0587': { // MULTIGIOCO - NEWGIOCO
      name: 'NEWGIOCO',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '76AF41F3-B7E3-4088-BF85-A4E65137E4CD': { // MULTIGIOCO - ORIGINALBET
      name: 'ORIGINALBET',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '766E6356-9748-4875-8D89-A83966BA0361': { // MULTIGIOCO - QUIBET
      name: 'QUIBET',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '7D4F7207-ADAC-4A69-8C8E-636CF124CC9F': { // MULTIGIOCO - TEKNOGAME
      name: 'TEKNOGAME',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '19148C48-017F-43B2-9510-CFF4048CED1D': { // MULTIGIOCO - TIMETOBET
      name: 'TIMETOBET',
      theme: 'multigioco-dark',
      customCss: false,
      sass: 'multigioco'
    },
    '27898781-7E0A-40CD-8687-63E7B67AE00E': { // Betpremium
      name: 'Betpremium',
      theme: 'betpremium',
      customCss: false,
      sass: 'betpremium'
    },
    '7859D046-3FC0-421D-93D4-7C6FB0BA6A0C': { // NETWIN - JOKANDO
      name: 'JOKANDO',
      theme: 'jokando',
      customCss: false,
      sass: 'netwin',
    },
    'BC4B5B16-0224-448E-8653-C1BA33E06C30': { // NETWIN - NETWIN
      name: 'NETWIN',
      theme: 'netwin',
      customCss: false,
      sass: 'netwin',
    },
    '9804E124-93A5-411C-AA7C-DD9E55153000': { // ADMIRAL
      name: 'ADMIRAL',
      theme: 'admiral',
      customCss: false
    },
    'EA93E1A8-F02E-4BC2-B57C-62CE44ABCA48': { // QUIGIOCO - ADMIRAL777
      name: 'ADMIRAL777',
      theme: 'admiral',
      customCss: false
    },
    'B55E93CF-E170-4732-8D3A-0E7F57271B93': { // FIVEBET - BETMATCH   L
      name: 'Betmatch',
      theme: 'mst',
      customCss: false,
      sass: 'fivebet'
    },
    '6E4A2A80-4CFE-4C39-9499-6A8F920EDFA5': { // FIVEBET - FIVEBET    L
      name: 'Fivebet',
      theme: 'mst',
      customCss: false,
      sass: 'fivebet'
    },
    '419060C3-060A-4FDD-B26A-D2CF7A734F8E': { // FIVEBET - VINCITUBET L
      name: 'Vincitubet',
      theme: 'mst',
      customCss: false,
      sass: 'fivebet'
    },
    'C79A79B2-F282-4D7F-A788-9E3EDB535D5B': { // FIVEBET - POINTBET   L
      name: 'Pointbet',
      theme: 'mst',
      customCss: false,
      sass: 'fivebet'
    },
    'EEB98811-9EAF-4E3D-85ED-E590CABFE698': { // FIVEBET - IAMBET     L
      name: 'Iambet',
      theme: 'mst',
      customCss: false,
      sass: 'fivebet'
    },
    '5747B1F7-C79D-4BAC-A0ED-8E8C3CEAF211': { // FIVEBET - FULLSLOT   D
      name: 'FULLSLOT',
      theme: 'mst-dark',
      customCss: false,
      sass: 'fivebet'
    },
    '6E698F05-A803-4A6B-B70A-4C9D6C3747E2': { // FIVEBET - GIOCOYES   D
      name: 'GIOCOYES',
      theme: 'mst-dark',
      customCss: false
    },
    '124BDC86-32B3-4552-803A-F046D6AA1BB8': { // FIVEBET - I7BETPLUS  D
      name: 'I7BETPLUS',
      theme: 'mst-dark',
      customCss: false,
      sass: 'fivebet'
    },
    '02961FA6-0F4E-4A76-A0FE-8E7E6333C1BD': { // FIVEBET - ONEGOL     D
      name: 'ONEGOL',
      theme: 'mst-dark',
      customCss: false,
      sass: 'fivebet'
    },
    'A94373A0-503E-4384-B0AF-753A3088C741': { // FIVEBET - POKER-BET  D
      name: 'POKER-BET',
      theme: 'mst-dark',
      customCss: false,
      sass: 'fivebet'
    },
    'E86E859D-E6BC-492D-A06A-8E78FC9585D4': { // FIVEBET - SPORTANDGAMES D
      name: 'SPORTANDGAMES',
      theme: 'mst-dark',
      customCss: false,
      sass: 'fivebet'
    },
    '33572647-84CA-4B0D-8125-BDDE1BEB45A9': { // FIVEBET - TIMEWIN       D
      name: 'TIMEWIN',
      theme: 'mst-dark',
      customCss: false,
      sass: 'fivebet'
    },
    'E9905018-0B43-4E5E-AE42-2FFA21586E38': {  //  BGAME - ALLINBET  L
      name: 'ALLINBET',
      theme: 'mst',
      customCss: false,
      sass: 'bgame',
    },
    '3E96A51C-9D08-401C-9DEA-59B9B3897C23': { //  BGAME - BBET  L
      name: 'BBET',
      theme: 'mst',
      customCss: false,
      sass: 'bgame',
    },
    '536D5050-0DEE-428A-A063-B56010E9BD8D': { //  BGAME - SOCIALGAME24  L
      name: 'SOCIALGAME24',
      theme: 'mst',
      customCss: false,
      sass: 'bgame',
    },
    '608FE4E0-D64D-4BB4-96F3-0259BDDD9C33': { //  BGAME - SPORTBULL L
      name: 'SPORTBULL',
      theme: 'mst',
      customCss: false,
      sass: 'bgame',
    },
    '1E2195F8-3E65-42EB-973C-5EBF529073C1': { //  BGAME - Q365      L
      name: 'Q365',
      theme: 'mst',
      customCss: false,
      sass: 'bgame'
    },
    '2F52B995-3847-4E44-B615-A53DC21B0E47': { //  BGAME - BGAME     D
      name: 'BGAME',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    '66FDB1F1-66CE-45AB-9A21-5CF7D9F7F8BA': { //  BGAME - BULLBET   D
      name: 'Mbet',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    '78DEE16B-D4EC-41E0-A9F9-A492C655F87E': { //  BGAME - DNGAMES   D
      name: 'DNGAMES',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    'F320FD01-1D09-43E3-B73E-E8B82E9A1AA5': { //  BGAME - GAM-X     D
      name: 'GAM-X',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    '1E4D54A5-3386-4402-8645-8A6B0960C2DE': {  //  BGAME - MINNIEBET D
      name: 'MINNIEBET',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    '782732C1-7376-4742-98DC-C380F1954DEA': {  //  BGAME - SKILLJOY  D
      name: 'SKILLJOY',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    'FEFB376B-13F7-4B22-84B4-0C57B0F1A635': {  //  BGAME - TOPBET24  D
      name: 'TOPBET24',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    '9116E751-1D17-470C-AF35-BE1CA0EA7CF7': { //  BGAME - UNIONSBET D
      name: 'UNIONSBET',
      theme: 'mst-dark',
      customCss: false,
      sass: 'bgame'
    },
    // casinobellagio LIGHT
    '5EB95E71-7256-47D8-0001-4D6EB8254636': {
      name: 'casinobellagio light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#00643A',
      brandColorTxt: '#fff'
    },
// casinobellagio DARK
    '5EB95E71-7256-47D8-0002-4D6EB8254636': {
      name: 'casinobellagio dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#00643A',
      brandColorTxt: '#fff'
    },
    // Bilionairebet LIGHT
    '80C35A32-0687-459C-0001-1376D8C13E57': {
      name: 'Bilionairebet light',
      theme: 'mst',
      customCss: true,
      link: 'theme-microgame-light',
      brandColor: '#E2C48E',
      brandColorTxt: '#212121'
    },
// Bilionairebet DARK
    '80C35A32-0687-459C-0002-1376D8C13E57': {
      name: 'Bilionairebet dark',
      theme: 'mst-dark',
      customCss: true,
      link: 'theme-microgame-dark',
      brandColor: '#E2C48E',
      brandColorTxt: '#212121'
    },
  },
};
